import { createContext, useContext, useEffect, useState } from "react";
import { 
  fetchCart,
  addItemToCart,
  updateCartQuantity,
  removeCartItem
 } from "../api/apiServices";

const CartContext = createContext(undefined);

export function CartProvider({ children }) {
  const [cartItems, setCartItems] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  // LOAD CART ON SITE OPEN
  useEffect(() => {
    loadCart();
  }, []);

  const loadCart = async () => {
    try {
      const data = await fetchCart();
      setCartItems(data.items || []);
    } catch (err) {
      console.log("Cart load error", err);
    } finally {
      setLoading(false);
    }
  };

  // ADD TO CART
  const addToCart = async (item, quantity = 1) => {
    await addItemToCart({
      productId: item.id,
      name: item.name,
      image: item.image,
      size: item.size,
      price: item.price,
      quantity
    });

    await loadCart();
    setIsCartOpen(true);
  };

  // REMOVE
  const removeFromCart = async (productId, size) => {
    await removeCartItem({productId, size});
    await loadCart();
  };

  // UPDATE
  const updateQuantity = async (productId, size, quantity) => {
    await updateCartQuantity({productId, size, quantity});
    await loadCart();
  };

  const clearCart = () => setCartItems([]);

  const cartTotal = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const cartCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
        cartTotal,
        cartCount,
        isCartOpen,
        setIsCartOpen,
        loading
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const context = useContext(CartContext);
  if (!context) throw new Error("useCart must be used within CartProvider");
  return context;
}
